import { styled } from 'styled-components'

const Wrapper = styled.div`
  padding: 16px 8px;
  color: ${(p) => p.theme.mutedText};
  font-size: 12px;
  font-style: italic;
`

const Note = (props) => {
  const { children } = props
  return <Wrapper>{children}</Wrapper>
}

export default Note
